module.exports = __webpack_public_path__ + "static/media/SIDDHI-KULKARNI.728003d9.png";